import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	InputSignal,
	Signal,
	signal,
	WritableSignal,
	inject,
} from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiDropdown } from '@taiga-ui/core'
import { OptionOrderInterface } from '@modules/options-module/orders/interfaces/option-order.interface'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { CancelOptionsOrderComponent } from '@shared/components/trading/orders/orders-options/tables/options/actions/cancel-options-order/cancel-options-order.component'
import { InfoOptionsOrderComponent } from '@shared/components/trading/orders/orders-options/tables/options/actions/info-options-order/info-options-order.component'
import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'
import { OptionsOrdersHelperService } from '@modules/options-module/orders/services/options-orders-helper.service'
import { ChangeOptionsOrderComponent } from '@shared/components/trading/orders/orders-options/tables/options/actions/change-options-order/change-options-order.component'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-options-opened-orders-actions',
	templateUrl: './options-opened-orders-actions.component.html',
	styleUrl: './options-opened-orders-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslatePipe,
		TuiDropdown,
		CancelOptionsOrderComponent,
		InfoOptionsOrderComponent,
		ChangeOptionsOrderComponent,
		ClickOutsideDirective,
		ButtonComponent,
	],
})
export class OptionsOpenedOrdersActionsComponent {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum
	protected readonly orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum

	public option: InputSignal<OptionOrderInterface | null> = input<OptionOrderInterface | null>(null)

	private readonly _optionsOrderHelperService: OptionsOrdersHelperService =
		inject<OptionsOrdersHelperService>(OptionsOrdersHelperService)

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)

	protected checkCanEdit: Signal<boolean> = computed<boolean>((): boolean => {
		const option: OptionOrderInterface | null = this.option()
		if (!option) return false

		return this._optionsOrderHelperService.checkCanEditOrder(option)
	})

	protected checkCanCancel: Signal<boolean> = computed<boolean>((): boolean => {
		const option: OptionOrderInterface | null = this.option()
		if (!option) return false

		return this._optionsOrderHelperService.checkCanCancel(option)
	})
	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this.openedDropdown.set(null)
	}
}
